module.exports = __webpack_public_path__ + "dcdeaf80ede707be9af239ddac627622.svg";